<template>
  <v-container fluid>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 sm6 md3>
        <v-container fluid grid-list-xs>
          <v-card class="rounded-card">
            <v-toolbar color="red" dark>
              <v-toolbar-title>Sign Up</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <!-- <v-flex align-center justify-center text-xs-center>
                    <div><h3>Sign up for an account</h3></div>
                  </v-flex> -->
                  <v-flex xs12
                    ><v-text-field
                      v-model="email"
                      type="text"
                      label="Email"
                    ></v-text-field
                  ></v-flex>
                  <v-flex xs12
                    ><v-text-field
                      v-model="password"
                      type="password"
                      label="Password"
                    ></v-text-field
                  ></v-flex>
                  <v-flex align-center justify-center text-xs-center>
                    <v-btn @click="signUp">Sign Up</v-btn>
                    <div>
                      <p />
                      or go back to
                      <router-link to="/login">login</router-link>.
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <FloatingNav />
  </v-container>
</template>

<script>
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import FloatingNav from "../components/FloatingNav.vue";

export default {
  name: "SignUp",
  components: { FloatingNav },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    async signUp() {
      const auth = getAuth();
      try {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          this.email,
          this.password
        );

        const user = userCredential && userCredential.user;
        if (user) {
          try {
            const db = getFirestore();
            const userRef = doc(db, "users", user.uid);
            await setDoc(
              userRef,
              {
                uid: user.uid,
                email: user.email || this.email,
                displayName: user.displayName || "",
                providerId:
                  (user.providerData &&
                    user.providerData[0] &&
                    user.providerData[0].providerId) ||
                  "password",
                createdAt:
                  (user.metadata && user.metadata.creationTime) ||
                  new Date().toISOString(),
                lastLoginAt:
                  (user.metadata && user.metadata.lastSignInTime) ||
                  (user.metadata && user.metadata.creationTime) ||
                  new Date().toISOString(),
              },
              { merge: true }
            );
          } catch (_e) {
            // Non-fatal: failure to write user profile should not block sign up
          }
        }

        this.$router.replace("/");
      } catch (err) {
        alert("Oops. " + (err && err.message ? err.message : err));
      }
    },
    goBack: function () {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.sign-up {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
button {
  margin-top: 10px;
  width: 10%;
  cursor: pointer;
}
span {
  display: block;
  margin-top: 20px;
  font-size: 11px;
}
</style>
